import type { GeoJsonFeatureCollection } from '@gpx-spa/geo-domain';
import { lineColorHexForShipmentDevice } from '@/map/operational/shipment-status-line-colors';
import type { ConvoyTrackSegment } from './types';

/**
 * Convert segments to path LineString features (no vertex circles — keep paint light).
 */
export function convoyTrackSegmentsToFeatureCollection(
  segments: readonly ConvoyTrackSegment[],
  status: string | undefined,
): GeoJsonFeatureCollection {
  const features: GeoJsonFeatureCollection['features'] = [];
  for (const seg of segments) {
    if (seg.coordinates.length < 2) continue;
    const lineColorHex = lineColorHexForShipmentDevice(
      status,
      seg.colorIndex,
    );
    features.push({
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: seg.coordinates,
      },
      properties: {
        map: {
          lineColor: lineColorHex,
          lineWidth: 3,
          lineOpacity: 0.85,
        },
        convoy: {
          groupKey: seg.groupKey,
          memberDeviceIds: seg.memberDeviceIds,
          colorIndex: seg.colorIndex,
        },
      },
    });
  }
  return { type: 'FeatureCollection', features };
}
